import React from 'react'

const DocLabel =(props)=>{
    const {formObject, viewData} = props

    const valCssClass = formObject.getValueFromKey(viewData, "dataList.valCssClass", "");
    // let value = formObject.getValueFromKey(viewData, "dataList.valS", viewData.valF || viewData.val);

    //TODO add support for converting the string based style to a react style
    //Original code below which is not working because of style
    // <div className={viewData.dataList.valCssClass ? viewData.dataList.valCssClass : ''} 
    // style={viewData.dataList.valCssStyle ? viewData.dataList.valCssStyle : ''}>{viewData.valF}</div>
    return (
        <div className="saras-cell">
            <div className={valCssClass}>
                {viewData.valF}
            </div>
        </div>
    )
}

export default DocLabel
